const englishLabels = {
  lastUpdated: 'Last updated',
  noteTitle: 'DriveReady specific document',
  noteBody: 'This page applies only to DriveReady. Other 2xHappiness apps may have separate privacy policies and terms.',
  contactBody: 'For privacy, support, or legal questions, contact',
};

export const driveReadyPrivacy = {
  locale: 'en',
  lastUpdated: 'July 16, 2026',
  title: 'Privacy Policy',
  intro: 'How DriveReady handles region and vehicle selections, language settings, study activity, device data, and support communications.',
  labels: englishLabels,
  sections: [
    {
      title: '1. Introduction and Scope',
      body: [
        'DriveReady (the “App”) is an offline-first driving knowledge exam preparation app operated by 2xHappiness (“we,” “us,” or “our”). This Privacy Policy explains how information is handled when you use the App.',
        'The App provides localized study plans, learning materials, practice questions, mock examinations, and progress tracking. This Policy applies only to DriveReady and not to other 2xHappiness products or third-party services.',
      ],
    },
    {
      title: '2. Information Stored on Your Device',
      body: [
        'DriveReady stores information locally so it can personalize your study experience and work without an account. This information remains on your device unless you choose to include it in a support message or your device backup service copies it under your operating system settings.',
      ],
      items: [
        'The state, province, region, or licensing jurisdiction you select;',
        'The vehicle or license class you select, such as passenger vehicle, motorcycle, or commercial vehicle;',
        'Your selected app language and whether onboarding has been completed;',
        'Practice session details, including session identifiers, question progress, selected answers, correctness results, and timestamps;',
        'Local question-bank and content version information used to provide the appropriate study materials.',
      ],
    },
    {
      title: '3. Device Language and Region Choices',
      body: [
        'When first opened, the App may read your device language setting to choose a supported display language. This check occurs on your device. DriveReady does not request precise or approximate GPS location.',
        'A state, province, or region selected in the App is a study preference that you enter yourself. It is not derived from GPS, Wi-Fi positioning, mobile network location, or other location sensors.',
      ],
    },
    {
      title: '4. Information We Do Not Collect in the Current Version',
      body: [
        'The current version of DriveReady does not require an account and does not include our own server-side user database, advertising SDK, analytics SDK, crash-reporting SDK, social login, cloud synchronization, subscription, or in-app purchase system.',
        'We do not currently collect or receive your name, postal address, phone number, contacts, messages, government identification, precise location, photos, camera or microphone content, health data, biometric data, payment card details, advertising identifier, or cross-app tracking data through the App.',
        'The production Android manifest does not request internet, location, camera, microphone, contacts, photo library, or advertising identifier permissions. Development and profiling builds may use internet access for debugging tools; those builds are not the consumer release described by this Policy.',
      ],
    },
    {
      title: '5. How Local Information Is Used',
      body: [
        'DriveReady uses local information to select relevant learning material, remember your preferences, resume practice sessions, calculate results and readiness indicators, show study history, provide mock examinations, and maintain the App.',
        'We do not sell local study information, use it for targeted advertising, or use it to create a profile about you across apps or websites.',
      ],
    },
    {
      title: '6. Support Communications',
      body: [
        'If you contact us by email, we receive the information you choose to provide, such as your email address, message, device or app details, and attachments. Please do not send sensitive personal information or confidential documents that are not necessary for support.',
        'We use support communications to respond to your request, troubleshoot issues, protect the App, and keep reasonable records of the request. We do not use support messages for advertising.',
      ],
    },
    {
      title: '7. App Stores, Operating Systems, and External Links',
      body: [
        'The platform from which you obtain DriveReady, such as Google Play or the Apple App Store, may independently process download, purchase, device, diagnostic, or account information under its own privacy policy. Your operating system may also provide device backup, security, or diagnostic services based on your settings.',
        'The App may open the DriveReady Privacy Policy, Terms of Service, support email, or other external resources in your browser or another app. Once you leave DriveReady, the destination service controls its own information practices.',
      ],
    },
    {
      title: '8. Data Sharing and Disclosure',
      body: [
        'Because current study data is kept locally, we do not share that data with advertisers, analytics providers, data brokers, or other users.',
        'We may disclose information that we actually hold, such as a support email, when reasonably necessary to comply with applicable law or legal process, respond to a lawful government request, protect users or the public, enforce our rights, investigate abuse, or complete a business transfer subject to applicable privacy protections.',
      ],
    },
    {
      title: '9. Retention, Deletion, and Your Choices',
      body: [
        'Local preferences and study records generally remain on your device until you reset relevant data, clear the App data, or uninstall DriveReady. Deleting the App may not immediately remove copies maintained by a device backup service; those copies are controlled through your device or account backup settings.',
        'You can change your language, region, and vehicle-class choices through available App settings. You can delete local App data through operating system controls or by uninstalling the App.',
        'Support communications are retained only as reasonably needed to resolve requests, maintain security and business records, comply with law, and handle disputes. You may ask us to delete personal information contained in support records, subject to legal exceptions, by contacting yuw558071@gmail.com.',
      ],
    },
    {
      title: '10. Security',
      body: [
        'We reduce privacy risk by keeping study activity on your device and limiting permissions and third-party services. You are responsible for maintaining the security of your device, screen lock, operating system account, backups, and any information you choose to send by email.',
        'No device, electronic storage method, or communication channel can be guaranteed to be completely secure. If we learn of a security issue that affects information we control, we will respond as required by applicable law.',
      ],
    },
    {
      title: '11. Children and Young Learners',
      body: [
        'DriveReady is a general-audience educational tool and is not designed to collect personal information from children. Core study features do not require an account or submission of personal information to us.',
        'A parent or guardian should supervise a minor’s use where required by law. If you believe a child has sent personal information to us through a support communication, contact us so we can review and delete it where appropriate.',
      ],
    },
    {
      title: '12. International Users',
      body: [
        'Local study data remains on the device and is not transferred to us. If you contact us, your communication may be processed in a country different from where you live. We handle such communications under this Policy and applicable law.',
        'Depending on your location, you may have rights to access, correct, delete, restrict, or object to processing of personal information we hold. To make a request, email yuw558071@gmail.com. We may need to verify the request before responding.',
      ],
    },
    {
      title: '13. Changes to This Policy',
      body: [
        'We may update this Privacy Policy when DriveReady, applicable law, or our information practices change. We will post the revised version on this page and update the date above. If a future version adds accounts, cloud synchronization, advertising, analytics, online content delivery, payments, or new permissions, we will revise this Policy before or when the new processing begins and request consent where required.',
      ],
    },
    {
      title: '14. Contact',
      body: [
        'Operator: 2xHappiness. Website: https://2xhappiness.com. For privacy questions or requests, email yuw558071@gmail.com.',
      ],
    },
  ],
};

export const driveReadyTerms = {
  locale: 'en',
  lastUpdated: 'July 16, 2026',
  title: 'Terms of Service',
  intro: 'The rules for using DriveReady study plans, practice questions, mock examinations, progress tracking, and related 2xHappiness services.',
  labels: englishLabels,
  sections: [
    {
      title: '1. Acceptance of Terms',
      body: [
        'By downloading, installing, accessing, or using DriveReady (the “App”), you agree to these Terms of Service and acknowledge the DriveReady Privacy Policy. If you do not agree, do not use the App.',
        'The App is operated by 2xHappiness (“we,” “us,” or “our”). These Terms apply only to DriveReady. Other 2xHappiness apps may have separate terms.',
      ],
    },
    {
      title: '2. Educational Purpose and No Government Affiliation',
      body: [
        'DriveReady is an independent educational study aid for driving knowledge examinations. Unless expressly stated otherwise, DriveReady and 2xHappiness are not affiliated with, sponsored by, endorsed by, or acting on behalf of any department of motor vehicles, transport ministry, licensing authority, government agency, testing provider, driving school, or vehicle manufacturer.',
        'The App does not issue licenses, schedule official examinations, submit government applications, verify eligibility, or replace official driver education, supervised training, professional instruction, or an official handbook.',
      ],
    },
    {
      title: '3. Study Content and Exam Results',
      body: [
        'The App may provide localized lessons, practice questions, explanations, readiness indicators, scores, and mock examinations based on the region and vehicle class you select. These features are for preparation and self-assessment only.',
        'Laws, road rules, signs, examination formats, passing scores, fees, and licensing requirements can change and may differ by jurisdiction. Although we aim to provide useful material, we do not guarantee that content is complete, current, error-free, identical to an official examination, or accepted by a licensing authority.',
        'A score, streak, readiness estimate, completed study plan, or mock-exam result does not guarantee eligibility, an appointment, a passing result, a license, safe driving ability, or any other outcome. Always verify important information with the current official handbook and the responsible licensing authority.',
      ],
    },
    {
      title: '4. Eligibility and Minors',
      body: [
        'You must be legally able to agree to these Terms. If you are under the age of majority where you live, you may use the App only with permission and supervision from a parent or legal guardian who agrees to these Terms on your behalf where required.',
        'Use of DriveReady does not establish that you meet the minimum age, residency, identity, medical, training, insurance, or other legal requirements to apply for or hold a driving privilege.',
      ],
    },
    {
      title: '5. Limited License',
      body: [
        'Subject to your compliance with these Terms, 2xHappiness grants you a limited, personal, non-exclusive, non-transferable, non-sublicensable, and revocable license to install and use DriveReady on devices you control for lawful, non-commercial study purposes.',
        'Except where applicable law expressly permits, you may not copy, modify, translate, distribute, sell, lease, sublicense, publicly display, create derivative works from, reverse engineer, decompile, extract source code from, bypass protections in, or commercially exploit the App or its content.',
      ],
    },
    {
      title: '6. Your Study Data and Device',
      body: [
        'DriveReady may store your region, vehicle class, language, answers, results, session progress, and related settings locally on your device. You are responsible for protecting your device and maintaining any backups you need.',
        'Local data may be changed, reset, or lost because of device failure, operating system behavior, storage cleanup, App updates, data clearing, uninstallation, or other circumstances. We do not guarantee recovery or synchronization of local study data.',
      ],
    },
    {
      title: '7. Safe and Lawful Use',
      body: [
        'Do not interact with DriveReady while driving, cycling, operating machinery, crossing a road, or in any situation where distraction could create danger. Use the App only when safely parked or otherwise in a safe place.',
        'You are responsible for obeying traffic laws, license restrictions, supervision requirements, device-use laws, and the instructions of qualified driving instructors and examiners. The App is not a substitute for attentive, lawful, and defensive driving.',
      ],
    },
    {
      title: '8. Prohibited Conduct',
      body: [
        'You may not use the App unlawfully; interfere with its security or operation; introduce malware; access non-public systems or data; automate extraction of substantial content; remove ownership notices; misrepresent App content as official government material; or use the App to infringe, deceive, harass, or harm another person.',
        'You may not reproduce or distribute question banks, explanations, artwork, interface elements, or other substantial App materials for a competing service, commercial training product, public answer repository, or unauthorized examination assistance.',
      ],
    },
    {
      title: '9. Intellectual Property',
      body: [
        'DriveReady, including its software, design, name, icon, interface, original question arrangements, explanations, graphics, and other original materials, is owned by 2xHappiness or its licensors and is protected by intellectual property laws.',
        'Government publications, official road signs, third-party trademarks, and other third-party or public-source materials remain the property of their respective owners and are used only as permitted by law. References to a jurisdiction or license class do not imply endorsement.',
      ],
    },
    {
      title: '10. External Services and App Stores',
      body: [
        'Your download and use of DriveReady may also be subject to the rules of the app store and operating system provider. If those platform rules conflict with these Terms, mandatory platform terms apply to the extent required.',
        'The App may open external websites, email tools, official resources, or other apps. We do not control and are not responsible for third-party content, availability, security, information practices, transactions, or terms. Review third-party terms before using those services.',
      ],
    },
    {
      title: '11. Updates, Availability, and Changes',
      body: [
        'Features, question sets, supported jurisdictions, vehicle classes, scoring methods, language support, and device compatibility may change over time. We may update, correct, limit, suspend, or discontinue any part of DriveReady at any time, subject to applicable law.',
        'We do not guarantee that the App will always be available, that every region or examination will be supported, or that an older App version will continue to function. You are responsible for installing updates where appropriate and checking official sources for current rules.',
      ],
    },
    {
      title: '12. Disclaimers',
      body: [
        'To the maximum extent permitted by law, DriveReady is provided on an “as is” and “as available” basis without warranties of any kind, whether express, implied, or statutory, including warranties of accuracy, completeness, currency, merchantability, fitness for a particular purpose, non-infringement, availability, or examination success.',
        'We do not provide legal, professional driving, safety, medical, insurance, or government advice. You assume responsibility for how you use study content and for confirming official requirements before making decisions or taking an examination.',
      ],
    },
    {
      title: '13. Limitation of Liability',
      body: [
        'To the maximum extent permitted by law, 2xHappiness and its licensors are not liable for indirect, incidental, special, consequential, exemplary, or punitive damages, or for loss of data, progress, opportunity, fees, income, goodwill, examination attempts, licensing outcomes, or other intangible losses arising from or related to DriveReady.',
        'Nothing in these Terms excludes or limits liability that cannot legally be excluded or limited. Where a jurisdiction does not allow a stated exclusion or limitation, it applies only to the maximum extent permitted there.',
      ],
    },
    {
      title: '14. Suspension and Termination',
      body: [
        'We may suspend or terminate access to all or part of the App if you materially violate these Terms, misuse the App, infringe rights, or create legal, security, or operational risk. You may stop using DriveReady at any time and uninstall it.',
        'Sections that by their nature should survive termination, including intellectual property, disclaimers, limitations of liability, and dispute provisions, remain effective after termination.',
      ],
    },
    {
      title: '15. Changes to These Terms',
      body: [
        'We may update these Terms as DriveReady, platform requirements, or applicable law changes. We will post the revised Terms on this page and update the date above. If a change is material, we may also provide an App or website notice where reasonably practical.',
        'Your continued use after revised Terms take effect means you accept them. If you do not accept an update, stop using and uninstall the App.',
      ],
    },
    {
      title: '16. Governing Rules and Disputes',
      body: [
        'These Terms are governed by the laws applicable to the operator, without limiting mandatory consumer protections or other non-waivable rights that apply where you live. Before starting formal proceedings, you and 2xHappiness agree to attempt in good faith to resolve a dispute through written communication where permitted by law.',
        'If any provision is held unenforceable, it will be limited or removed only to the minimum extent necessary, and the remaining provisions will continue in effect. Our failure to enforce a provision is not a waiver of it.',
      ],
    },
    {
      title: '17. Contact',
      body: [
        'Operator: 2xHappiness. Website: https://2xhappiness.com. Questions about these Terms may be sent to yuw558071@gmail.com.',
      ],
    },
  ],
};
